import { gql } from "@apollo/client";

export default gql`
  query mySkills {
    mySkills {
      id
      name
      slug
      description
      body
      visibility
      canEdit
      canArchive
      updated
      created
    }
  }
`;
